import { ref, readonly, computed, watch } from 'vue-demi';
import { FORM_STATES, ALL_TOPIC } from '../constants/constants';
import lowerWithoutAccent from '../../../common/js/lower-without-accent/lowerWithoutAccent';
import newsApi from '../../../api/news-api';

const header = ref(null);
const formState = ref(FORM_STATES.FORM);
const loadingWithParams = ref(false);

const newsList = ref(null);
const newsTags = ref(null);

const selectedTag = ref(ALL_TOPIC);
const currentPage = ref(1);
const pageSize = ref(10);

const newsParams = computed(() => {
	return {
		pageNo: currentPage.value - 1,
		pageSize: pageSize.value,
		tag: selectedTag.value == ALL_TOPIC ? null : selectedTag.value
	};
});

const newsUrl = computed(() => window.location.origin + '/News/' + lowerWithoutAccent(selectedTag.value || ALL_TOPIC) + '/' + currentPage.value);

watch([selectedTag, currentPage], (currentValue, newValue) => {
	const tagChanged = currentValue[0] != newValue[0];
	const pageChanged = currentValue[1] != newValue[1];
	if (tagChanged && currentPage.value != 1 && !loadingWithParams.value) {
		currentPage.value = 1;
	} else if (tagChanged || pageChanged) {
		loadingWithParams.value = false;
		getNews();
		window.history.pushState({}, '', newsUrl.value);
	}
});
const loadNewsWithParams = () => {
	const path = window.location.pathname;
	const pathNames = path.split('/');
	const newsIndex = pathNames.indexOf('News');
	const tag = newsTags.value.find((tag) => lowerWithoutAccent(tag) == pathNames[newsIndex + 1]) || pathNames[newsIndex + 1];
	const pageNo = pathNames[newsIndex + 2];
	if (tag) {
		loadingWithParams.value = true;
		selectedTag.value = tag;
		currentPage.value = parseInt(pageNo) || currentPage.value;
	} else {
		getNews(false);
	}
};
const getNews = async (scrollToTop = true) => {
	try {
		formState.value = FORM_STATES.LOADING;
		const { data } = await newsApi.getNews(newsParams.value);
		newsList.value = data;
		if (newsList.value.content.length) {
			formState.value = FORM_STATES.FORM;
		} else {
			formState.value = FORM_STATES.NO_RESULT;
		}
		scrollToTop && header.value.focus();
	} catch (err) {
		formState.value = FORM_STATES.TECHNICAL_ERROR;
	}
};

export const useNewsList = () => {
	return {
		newsList: readonly(newsList)
	};
};

export const useNewsTags = () => {
	const getNewsTags = async () => {
		try {
			const { data } = await newsApi.getTags();
			newsTags.value = data;
			newsTags.value.push(ALL_TOPIC);
			loadNewsWithParams();
		} catch (err) {
			console.error('Cannot get tags');
		}
	};
	getNewsTags();
	return {
		newsTags: readonly(newsTags)
	};
};

export const useNewsStore = () => {
	const selectTag = (newsTag) => {
		selectedTag.value = newsTag;
	};
	const setPageSize = (size) => {
		pageSize.value = size;
	};

	const totalRows = computed(() => (newsList.value ? newsList.value.totalElements : 0));

	return {
		selectedTag,
		currentPage,
		totalRows,
		header,
		formState,
		selectTag,
		setPageSize,
		loadNewsWithParams
	};
};
